import {useTranslation} from "react-i18next"

import {LocaleContextType, ValidLocale} from "./Locales"

export const useLocale = (): LocaleContextType => {
	const {i18n} = useTranslation()

	return {
		locale: i18n.language as ValidLocale, // default to en-AU
		layoutDir: i18n.dir(i18n.language),
		isRTL: i18n.dir(i18n.language) === "rtl",
	}
}
